import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormGroup} from "@angular/forms";
import {EntitySchemaService} from "@catcore/services/entity-schema.service";
import {ProjectService} from "@catcore/services";
import {Project} from "@catcore/types/api-v2";
import {isNullOrUndefined} from "util";

@Component({
  selector: 'cat-ggw-perform-action',
  templateUrl: './ggw-perform-action.component.html',
  styleUrls: ['./ggw-perform-action.component.scss']
})
export class GgwPerformActionComponent implements OnInit {

  @Input() project: Project;
  @Input() _parentForm: FormGroup;
  @Input() ggwDeviceOptions: any[];

  @Output() onUp: EventEmitter<any> = new EventEmitter();
  @Output() onDown: EventEmitter<any> = new EventEmitter();
  @Output() onDelete: EventEmitter<any> = new EventEmitter();
  @Output() refreshDeviceSelection: EventEmitter<any> = new EventEmitter();

  deviceRoleOptions = [];
  deviceSelectionEnabled = false;

  private _lastChoice = null;

  constructor(private schemaService: EntitySchemaService) { }

  ngOnInit() {
    const actionsSchema = this.schemaService.getForResourceUri("/api/project-ggw-perform-actions");
    this.deviceRoleOptions = [];
    actionsSchema.properties.device_role.choices
      .filter((choice) => choice !== null)
      .forEach((choice) => {
      this.deviceRoleOptions.push({value: choice, label: choice});
    });
  }

  @Input()
  set parentForm(form) {
    this._parentForm = form;
    this.deviceSelectionEnabled = (!isNullOrUndefined(form.value.device) && form.value.device !== '');
    if (this.deviceSelectionEnabled) {
      this.refreshDeviceSelection.emit();
    }
  }

  get parentForm() {
    return this._parentForm;
  }

  delete() {
    this.onDelete.emit();
  }

  up() {
    this.onUp.emit();
  }

  down() {
    this.onDown.emit();
  }

  enableDeviceSelection() {
    this.refreshDeviceSelection.emit();
    if (this._lastChoice !== null) {
      this.parentForm.patchValue({device: this._lastChoice});
    }
    this.deviceSelectionEnabled = true;
    this._lastChoice = this.parentForm.value.device_role;
    this.parentForm.patchValue({device_role: null});
  }

  disableDeviceSelection() {
    if (this._lastChoice !== null) {
      this.parentForm.patchValue({device_role: this._lastChoice});
    }
    this.deviceSelectionEnabled = false;
    this._lastChoice = this.parentForm.value.device;
    this.parentForm.patchValue({device: null});
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/ggw-dynamic-routes/components/ggw-perform-action/ggw-perform-action.component.ts